<template>
  <v-snackbar v-model="show" :color="color" :timeout="clientConfig.popupTimeout" location="top">
    <!-- {{ /* AOV3-823 TODO: move snackbar to bottom to match pricing? */ }} -->
    <div class="d-flex align-center">
      <div class="notification-wrapper w-100">
        {{ message }}
      </div>
      <v-btn variant="text" @click="show = false">
        {{ $t('actions.close') }}
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
import { mapState, mapStores } from 'pinia';

// Stores
import { useContextStore } from '@/stores/context';
import { useSnackbarStore } from '@/stores/snackbar';

export default {
  data() {
    return {
      show: false,
      message: '',
      color: '',
    };
  },

  computed: {
    ...mapState(useContextStore, ['clientConfig']),
    ...mapStores(useSnackbarStore),
  },

  created() {
    this.snackbarStore.$onAction(({ name, store, after }) => {
      if (name === 'showSnackbar') {
        after(() => {
          this.message = store.content;
          this.color = store.color;
          this.show = true;
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.notification-wrapper {
  word-wrap: break-word;
  font-size: 1.2rem;
}
</style>
